export default [{
        path: "/",
        name: "dashboard",
        meta: { authRequired: true },
        component: () =>
            import ("./views/dashboards/default"),
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import ("./views/account/login"),
        meta: { authRequired: false },
    },
    {
        path: "/register",
        name: "Register",
        component: () =>
            import ("./views/account/register"),
        meta: { authRequired: false },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () =>
            import ("./views/account/forgot-password"),
        meta: {
            authRequired: false
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () =>
            import ("./views/account/logout"),
        meta: {
            authRequired: true,
        },
    },

    /************* USERS **************/
    {
        path: "/users",
        name: "users",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/users/index.vue"),
    },
    {
        path: "/users/:id",
        name: "users_show",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/users/show.vue"),
    },


    /************* MANAGERS **************/
    {
        path: "/managers",
        name: "managers",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/managers/index.vue"),
    },
    {
        path: "/managers/:id",
        name: "managers_show",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/managers/show.vue"),
    },


    /************* AGENTS **************/
    {
        path: "/agents",
        name: "agents",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/agents/index.vue"),
    },
    {
        path: "/agents/:id",
        name: "agents_show",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/agents/show.vue"),
    },


    /************* AGENTS ACCOUNT **************/
    {
        path: "/agents-accounts",
        name: "agents_accounts",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/agents_accounts/index.vue"),
    },
    {
        path: "/agents-accounts/:id",
        name: "agents_accounts_show",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/agents_accounts/show.vue"),
    },{
        path: "/wallets",
        name: "wallets",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/wallets/index.vue"),
    },{
        path: "/wallets/:id",
        name: "wallets_show",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/wallets/show.vue"),
    },

    {
        path: "/transfers-users",
        name: "trans",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/transfer-user/index.vue"),
    },{
        path: "/transfers-users/:id",
        name: "trans_show",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/transfer-user/show.vue"),
    },

    


    /************* COUNTRIES **************/
    {
        path: "/countries",
        name: "countries",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/definitions/countries/index.vue"),
    },

    /************* CURRENCIES **************/
    {
        path: "/currencies",
        name: "currencies",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/definitions/currencies/index.vue"),
    },

    /************* CONSTANTES **************/
    {
        path: "/constantes",
        name: "constantes",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/divers/constantes/index.vue"),
    },

    /************* CONTACTS **************/
    {
        path: "/contacts",
        name: "contacts",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/divers/contacts/index.vue"),
    },

    /************* MOYENS **************/
    {
        path: "/moyens",
        name: "moyens",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/moyens/index.vue"),
    },

    /************* ECHANGES **************/
    {
        path: "/exchanges",
        name: "exchanges",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/exchanges/index.vue"),
    },

    /************* AGGREGATORS **************/
    {
        path: "/aggregators",
        name: "aggregators",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/aggregators/index.vue"),
    },

    /************* AGGREGATORS METHODES **************/
    {
        path: "/aggregators-methods",
        name: "aggregators-methods",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/aggregators-methods/index.vue"),
    },

    /************* AGGREGATORS TRANSACTIONS **************/
    {
        path: "/aggregators-transactions",
        name: "aggregators-transactions",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/aggregators-transactions/index.vue"),
    },

    /************* AGGREGATORS SUMMARIES **************/
    {
        path: "/aggregators-summaries",
        name: "aggregators-summaries",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/aggregators-summaries/index.vue"),
    },

    /************* MOYENS **************/
    {
        path: "/conversions",
        name: "conversions",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/conversions/index.vue"),
    },

    /************* FILES **************/
    {
        path: "/files",
        name: "files",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/divers/files/index.vue"),
    },

    /************* TRANSACTIONS **************/
    {
        path: "/transfers/:id",
        name: "transfer",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/transfers/show.vue"),
    },
    {
        path: "/transfers",
        name: "transfers",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/transfers/index.vue"),
    },


    {
        path: "/payments",
        name: "payments",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/payments/index.vue"),
    },

     {
        path: "/payouts",
        name: "payouts",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/payouts/index.vue"),
    },




    /********* GENERAL ****** */
    {
        path: "/notifications",
        name: "notifications",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/general/notifications"),
    },

    {
        path: "/profile",
        name: "profile",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/general/profile"),
    },

    {
        path: "/setting",
        name: "setting",
        meta: { authRequired: true },
        component: () =>
            import ("./views/pages/general/setting"),
    },



    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    // {
    //     path: "*",
    //     redirect: "404",
    // },
    {
        path: "/pages/maintenance",
        name: "Maintenance",
        meta: { authRequired: true },
        component: () =>
            import ("./views/utility/maintenance"),
    },
    {
        path: "/pages/coming-soon",
        name: "coming-soon",
        meta: { authRequired: true },
        component: () =>
            import ("./views/utility/coming-soon"),
    },
    {
        path: "/pages/404",
        name: "Error-404",
        meta: { authRequired: true },
        component: () =>
            import ("./views/utility/404"),
    },
    {
        path: "/pages/500",
        name: "Error-500",
        meta: { authRequired: true },
        component: () =>
            import ("./views/utility/500"),
    },

    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: () =>
            import ("./views/utility/404"),
    }
];